//import React from 'react';
import React, { useRef } from 'react';
//import cn from "classnames";
//import majesticHotelExteriorJpg from '../../../assets/images/properties/Majestic-Hotel/Majestic-Hotel-Exterior.jpg';

const ScrollablePhone = () => {

    /*
    //let phoneScrollerDiv = React.createRef();
    let phoneScrollerDiv = useRef(null);
    let phoneScrollerDivScrollTop = 0;

    //const scrollEvent = (event) => { console.log(event); }
    //const scrollEvent = (event) => { console.debug('scrollEvent()'); }
    const scrollEvent = (event) => {
        console.debug('scrollEvent()', event);
        console.debug(`phoneScrollerDiv.current = ${ phoneScrollerDiv.current }`);
        //phoneScrollerDiv.current.scrollTo(0, 10);
        phoneScrollerDiv.current.scrollTop = phoneScrollerDivScrollTop++;
        console.debug(`phoneScrollerDiv.current.scrollTop = ${ phoneScrollerDiv.current.scrollTop }`);
    }
    //const scrollEvent = (event) => { console.log(event); }
    //const clickElement = (event) => { console.log(event); }
    const clickElement = (event) => { console.debug('clickElement()'); }
    const handleScroll = (event) => {
        console.debug('User scrolled!');
    };
    */

    return (
        <div>

            <div
                //className = 'scrollable-phone'
                style = {{
                    //maxHeight: '700px'
                    //, overflow: 'scroll'
                    //, overflowY: 'auto'
                    //, overflow: 'hidden'
                    position: 'relative'
                      //outline: 'green 1px solid'
                    , height: '700px'
                    , maxHeight: '700px'
                    , width: '390px'
                    //, width: '100%'
                    //, maxWidth: '390px'
                    //, overflow: 'auto'
                }}
                //onScroll = { handleScroll }
                //onScroll = { (event) => scrollEvent(event) }
                >

                <img
                    //src = 'images/product/Capture-RealSplit-Mobile-Mock-up.PNG'
                    src = 'images/Sensei-Labs/iPhone-Overlay/iPhone-Overlay-Top.png'
                    //src = 'images/Sensei-Labs/iphone_scoller.jpg'
                    style = {{
                          position: 'absolute'
                        , left: '0'
                        , maxWidth: '390px'
                        //, width: '390px'
                        //, display: 'none'
                    }}
                    />

                <img
                    src = 'images/Sensei-Labs/iPhone-Overlay/iPhone-Overlay-Left_40x1368.png'
                    style = {{
                          position: 'absolute'
                        , top: '57px'
                        , left: '0px'
                        , height: '582px'
                        , width: '20px'
                        //, maxHeight: '700px'
                        //, position: 'fixed'
                        //, position: 'sticky'
                    }}
                    />

                <div
                    style = {{
                        height: '700px'
                        , paddingTop: '16px'
                    }}
                    >

                <div
                    //className = 'scrollable-phone'
                    style = {{
                        //maxHeight: '700px'
                        //, overflow: 'scroll'
                        //, overflowY: 'auto'
                        //, overflow: 'hidden'
                        //position: 'relative'
                          //outline: 'green 1px solid'
                        //  height: '700px'
                        //, maxHeight: '700px'
                          height: '666px'
                        , width: '348px'
                        , overflow: 'auto'
                        , margin: 'auto'
                        , textAlign: 'center'
                        //, marginTop: '16px'
                        //, paddingTop: '16px'
                        , backgroundColor: 'white'
                        //, borderRadiusTopLeft: '20px'
                        //, borderTopLeftRadius: '20px'
                        //, borderTopRightRadius: '20px'
                        , borderRadius: '45px'
                        //, scrollbarColor: '#021735'
                        , scrollbarWidth: 'none'
                    }}
                    //onScroll = { handleScroll }
                    //onScroll = { (event) => scrollEvent(event) }
                    >

                    <img
                        src = 'images/Sensei-Labs/iphone_scoller.jpg'
                        style = {{
                            width: '100%'
                            //width: '380px'
                            , margin: 'auto'
                            , textAlign: 'center'
                            //, borderTop: 'white 10px solid'
                            //, display: 'none'
                            //, marginTop: '20px'
                            , paddingTop: '50px'
                            , paddingBottom: '50px'
                            , borderTopRightRadius: '20px'
                        }}
                        />
                </div>

                </div>

                <img
                    src = 'images/Sensei-Labs/iPhone-Overlay/iPhone-Overlay-Right_44x1368.png'
                    style = {{
                          position: 'absolute'
                        , top: '57px'
                        , right: '0'
                        , height: '582px'
                        , width: '22px'
                        //, maxHeight: '700px'
                    }}
                    />

                <img
                    src = 'images/Sensei-Labs/iPhone-Overlay/iPhone-Overlay-Bottom_789x125.png'
                    style = {{
                          position: 'absolute'
                        , bottom: '0'
                        , left: '0'
                        , width: '390px'
                        //, width: '100%'
                        //, maxWidth: '390px'
                        //, marginBottom: '-25px'
                    }}
                    />

            </div>
        </div>
    );
}

export default ScrollablePhone;
